import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import { ApiError } from "@/services/api";
import {
  ReadContractorVisit,
  UpdateContractorVisit,
} from "@/types/contractorVisit";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getApiErrorDescription } from "@/lib/utils/getApiErrorDescription";

export const useUpdateContractorVisitsMutation = (
  contractorVisitId?: string,
) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation<ReadContractorVisit, ApiError, UpdateContractorVisit[]>({
    mutationFn: (values: UpdateContractorVisit[]) =>
      ContractorVisitsService.patch(values),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: contractorVisitId
          ? [Module.ContractorVisits, contractorVisitId]
          : [Module.ContractorVisits],
      });
      toast({
        title: t("projectContractorVisits.success.update"),
      });
    },
    onError: (error) => {
      toast({
        title: t("projectContractorVisits.errors.update"),
        description: getApiErrorDescription(error, t),
        variant: "destructive",
      });
    },
  });
};
